import React, {useState} from 'react'
import {connect} from 'react-redux'
import { useParams } from 'react-router-dom';
import { Navigate } from 'react-router-dom'
import {addToast} from '../../../store/actions/toasts' 
import { store } from '../../../Store'
import { history } from '../../../Router'
// import { history } from '../../../history'

import withErrorHandler from '../../../hocs/withErrorHandler'
import axios from '../../../httpClients/axios-datamerch'
import * as actions from '../../../store/actions'

import { UserForm } from '../../../components/User';
import { CircularProgress, Backdrop } from '@mui/material';
import useClasses from '../../../helpers/useClasses';
import { useLocation, useNavigate } from 'react-router'

const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  backdrop: {
    zIndex: '100'
  }
});

const UserAdd = props => {
  const { onUserSave, onSaveError, account_resource_id, token, is_dm_admin, user_account_primary_email, user_account_member_email_domain } = props;
  // let { funder_id } = props.match.params
  let { funder_id } = useParams()
  let account_view = false
  if (!funder_id) {
    funder_id = account_resource_id
    account_view = true
  }
  const [user] = useState({
    firstName: '',
    lastName: '',
    email: ''
  })
  const classes = useClasses(styles);

  let navigate = useNavigate()

  const validateEmail = (email, user_account_member_email_domain) => {
    if (is_dm_admin){
      return true;
    }

    return user_account_member_email_domain.includes(email.split('@')[1])
  }

  const handleSubmitClick = (event, user) => {
    event.preventDefault();
    // let user_account_primary_email_split = user_account_primary_email.split('@')
    // if (user_account_member_email_domain.length < 2){
    //   history.push(`/logout`)
    // } else {

      if (validateEmail(user.email, user_account_member_email_domain)) {
        const userData = {
          user: {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email
          }
        }
        onUserSave(token, funder_id, userData)
        let current_url = window.location.pathname

        if (current_url === '/account/members/new'){
          navigate('/account')
        } else {
          current_url = current_url.split('/').slice(0, -2).join('/')
          navigate(current_url) 
        }
      } else {
        onSaveError({
          message: `Only email addresses ending in @${user_account_member_email_domain} are valid.`,
          severity: 'error',
          duration: null
        })
        return false;
      }

      // console.log(user_account_primary_email)
      // const userData = {
      //   user: {
      //     firstName: user.firstName,
      //     lastName: user.lastName,
      //     email: user.email
      //   }
      // }
      // onUserSave(token, funder_id, userData)
    // }
  };

  let spinner = (
    <Backdrop className={classes.backdrop} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  )
  if(!props.saving && !props.loading){
    spinner = null
  }

  // let redirect_url = `/funders/${funder_id}`
  // if (account_view) {
  //   redirect_url = `/account`
  // }
  // let userForm = <Redirect to={redirect_url} />
  
  // if ( !props.id ) {
  //   userForm = (
  //       <div className={classes.root}>
  //         <div className={classes.content}>
  //           <UserForm user={user} onSubmitClick={handleSubmitClick} mode='add' />
  //           {spinner}
  //         </div>
  //       </div>
  //     );
  // }

  const userForm = (
          <div className={classes.root}>
            <div className={classes.content}>
              <UserForm user={user} onSubmitClick={handleSubmitClick} mode='add' />
              {spinner}
            </div>
          </div>
        );
  
  return userForm;
};

const mapStateToProps = state => {
  return {
    saving: state.user.saving,
    loading: state.user.loading,
    // id: state.user.id,
    token: state.auth.token,
    account_resource_id: state.auth.user.account_resource_id,
    user_account_primary_email: state.auth.user.account_primary_email,
    user_account_member_email_domain: state.auth.user.account_member_email_domain,
    is_dm_admin: state.auth.user.is_dm_admin
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onUserSave: (token, accountId, userData) => dispatch(actions.addUser(token, accountId, userData)),
    onSaveError: (options) => dispatch(actions.addToast(options))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(UserAdd, axios))